'use client'

import { useState } from 'react'

import PlayTriangle from '/react4xp/components/prototype/icons/PlayTriangle'

import type { VideoProps } from './types'

export default function Video({
	videoId,
	videoUpload,
	thumbnail,
	playLabel = 'Play video',
	isPart = false,
}: VideoProps) {
	const [isPlaying, setIsPlaying] = useState(false)

	if (!videoId && !videoUpload) return null

	let content: React.ReactNode

	if (isPlaying) {
		content = (
			<div className="relative aspect-video w-full">
				{videoUpload ? (
					<video className="h-full w-full" controls playsInline autoPlay>
						<source src={videoUpload.src} />
					</video>
				) : (
					<iframe
						className="h-full w-full"
						src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`}
						title={playLabel}
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
					/>
				)}
			</div>
		)
	} else if (videoUpload && !thumbnail) {
		content = (
			<div className="relative aspect-video w-full">
				<video className="h-full w-full" controls playsInline>
					<source src={videoUpload.src} />
				</video>
			</div>
		)
	} else if (videoId && !thumbnail) {
		content = (
			<div className="relative aspect-video w-full">
				<iframe
					className="h-full w-full"
					src={`https://www.youtube-nocookie.com/embed/${videoId}`}
					title={playLabel}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				/>
			</div>
		)
	} else {
		content = (
			<div className="relative aspect-video w-full">
				{thumbnail && (
					<figure className="h-full w-full">
						<img src={thumbnail.src} alt={thumbnail.alt} className="h-full w-full object-cover" />
					</figure>
				)}
				<button
					type="button"
					aria-label={playLabel}
					onClick={() => setIsPlaying(true)}
					className="absolute inset-0 m-auto flex size-16 shrink-0 items-center justify-center rounded-full bg-brand-950 transition-opacity hover:opacity-90"
				>
					<PlayTriangle className="h-6 w-6.25 text-black-200" />
				</button>
			</div>
		)
	}

	if (isPart) {
		return <div className="container my-16">{content}</div>
	}

	return <div className="my-12">{content}</div>
}
